import React from 'react';

export const ChatBubbleLoader: React.FC = () => {
  return (
    <li className="animate-message-in px-5 py-2 pt-5">
      <div className="inline-flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <span
            key={i}
            className="inline-block h-2 w-2 animate-wave rounded-full"
            style={{ animationDelay: `${i * 0.1}s` }}
          />
        ))}
      </div>
    </li>
  );
};
